var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 469,
    viewBox: "0 0 1920 469",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4334_13726",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1920,
    height: 469
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 469,
    fill: "white",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 41.7188,
    width: 1,
    height: 469,
    fill: "white",
    fillOpacity: 0.1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 83.4336,
    width: 1,
    height: 469,
    fill: "white",
    fillOpacity: 0.1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 125.152,
    width: 1,
    height: 469,
    fill: "white",
    fillOpacity: 0.1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 166.871,
    width: 1,
    height: 469,
    fill: "white",
    fillOpacity: 0.1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 208.586,
    width: 1,
    height: 469,
    fill: "white",
    fillOpacity: 0.1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 250.305,
    width: 1,
    height: 469,
    fill: "white",
    fillOpacity: 0.1
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 292.023,
    width: 1,
    height: 469,
    fill: "white",
    fillOpacity: 0.1
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 333.738,
    width: 1,
    height: 469,
    fill: "white",
    fillOpacity: 0.1
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 375.457,
    width: 1,
    height: 469,
    fill: "white",
    fillOpacity: 0.1
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 417.176,
    width: 1,
    height: 469,
    fill: "white",
    fillOpacity: 0.1
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 458.891,
    width: 1,
    height: 469,
    fill: "white",
    fillOpacity: 0.1
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 500.609,
    width: 1,
    height: 469,
    fill: "white",
    fillOpacity: 0.1
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 542.328,
    width: 1,
    height: 469,
    fill: "white",
    fillOpacity: 0.1
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 584.043,
    width: 1,
    height: 469,
    fill: "white",
    fillOpacity: 0.1
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 625.762,
    width: 1,
    height: 469,
    fill: "white",
    fillOpacity: 0.1
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 667.477,
    width: 1,
    height: 469,
    fill: "white",
    fillOpacity: 0.1
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 709.195,
    width: 1,
    height: 469,
    fill: "white",
    fillOpacity: 0.1
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 750.914,
    width: 1,
    height: 469,
    fill: "white",
    fillOpacity: 0.1
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 792.629,
    width: 1,
    height: 469,
    fill: "white",
    fillOpacity: 0.1
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 834.348,
    width: 1,
    height: 469,
    fill: "white",
    fillOpacity: 0.1
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 876.066,
    width: 1,
    height: 469,
    fill: "white",
    fillOpacity: 0.1
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 917.781,
    width: 1,
    height: 469,
    fill: "white",
    fillOpacity: 0.1
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 959.5,
    width: 1,
    height: 469,
    fill: "white",
    fillOpacity: 0.1
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 1001.22,
    width: 1,
    height: 469,
    fill: "white",
    fillOpacity: 0.1
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 1042.93,
    width: 1,
    height: 469,
    fill: "white",
    fillOpacity: 0.1
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 1084.65,
    width: 1,
    height: 469,
    fill: "white",
    fillOpacity: 0.1
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 1126.37,
    width: 1,
    height: 469,
    fill: "white",
    fillOpacity: 0.1
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 1168.09,
    width: 1,
    height: 469,
    fill: "white",
    fillOpacity: 0.1
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 1209.8,
    width: 1,
    height: 469,
    fill: "white",
    fillOpacity: 0.1
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 1251.52,
    width: 1,
    height: 469,
    fill: "white",
    fillOpacity: 0.1
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 1293.24,
    width: 1,
    height: 469,
    fill: "white",
    fillOpacity: 0.1
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 1334.96,
    width: 1,
    height: 469,
    fill: "white",
    fillOpacity: 0.1
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 1376.68,
    width: 1,
    height: 469,
    fill: "white",
    fillOpacity: 0.1
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 1418.39,
    width: 1,
    height: 469,
    fill: "white",
    fillOpacity: 0.1
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 1460.11,
    width: 1,
    height: 469,
    fill: "white",
    fillOpacity: 0.1
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 1501.83,
    width: 1,
    height: 469,
    fill: "white",
    fillOpacity: 0.1
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 1543.54,
    width: 1,
    height: 469,
    fill: "white",
    fillOpacity: 0.1
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 1585.26,
    width: 1,
    height: 469,
    fill: "white",
    fillOpacity: 0.1
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 1626.98,
    width: 1,
    height: 469,
    fill: "white",
    fillOpacity: 0.1
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 1668.7,
    width: 1,
    height: 469,
    fill: "white",
    fillOpacity: 0.1
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 1710.41,
    width: 1,
    height: 469,
    fill: "white",
    fillOpacity: 0.1
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 1752.13,
    width: 1,
    height: 469,
    fill: "white",
    fillOpacity: 0.1
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 1793.85,
    width: 1,
    height: 469,
    fill: "white",
    fillOpacity: 0.1
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 1835.57,
    width: 1,
    height: 469,
    fill: "white",
    fillOpacity: 0.1
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 1877.28,
    width: 1,
    height: 469,
    fill: "white",
    fillOpacity: 0.1
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 1919,
    width: 1,
    height: 469,
    fill: "white",
    fillOpacity: 0.1
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1,
    fill: "white",
    fillOpacity: 0.1
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    y: 42.5454,
    width: 1920,
    height: 1,
    fill: "white",
    fillOpacity: 0.1
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    y: 85.0908,
    width: 1920,
    height: 1,
    fill: "white",
    fillOpacity: 0.1
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    y: 127.636,
    width: 1920,
    height: 1,
    fill: "white",
    fillOpacity: 0.1
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    y: 170.182,
    width: 1920,
    height: 1,
    fill: "white",
    fillOpacity: 0.1
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    y: 212.727,
    width: 1920,
    height: 1,
    fill: "white",
    fillOpacity: 0.1
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    y: 255.273,
    width: 1920,
    height: 1,
    fill: "white",
    fillOpacity: 0.1
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    y: 297.818,
    width: 1920,
    height: 1,
    fill: "white",
    fillOpacity: 0.1
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    y: 340.364,
    width: 1920,
    height: 1,
    fill: "white",
    fillOpacity: 0.1
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    y: 382.909,
    width: 1920,
    height: 1,
    fill: "white",
    fillOpacity: 0.1
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    y: 425.455,
    width: 1920,
    height: 1,
    fill: "white",
    fillOpacity: 0.1
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    y: 468,
    width: 1920,
    height: 1,
    fill: "white",
    fillOpacity: 0.1
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4334_13726)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 469,
    fill: "url(#paint0_linear_4334_13726)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4334_13726",
    x1: 960,
    y1: 0,
    x2: 960,
    y2: 469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.b5857883bc661628171891a19392f582.svg";
export { ForwardRef as ReactComponent };